<template>
  <div class="hero-section">
    <div class="hero-blob hero-blob--1" aria-hidden="true" />
    <div class="hero-blob hero-blob--2" aria-hidden="true" />
    <div class="hero-blob hero-blob--3" aria-hidden="true" />
    <div class="row align-items-center">
      <div class="col-lg-6 col-xl-5">
        <div class="text-container">
          <h1 class="h1-large mb-4">
            <span class="text-gradient">Disekolah Saja</span>
          </h1>
          <p class="p-large mb-5 text-muted">
            Kami menghadirkan layanan dan Integrasi terbaik PPDB, PSB, Daftar ulang, Pembelajaran Online, Rekap Absensi,
            Sistem Manajemen dan kebutuhan Transaksi - Pembayaran non tunai di Sekolah. Penggunaan aplikasi
            <strong class="text-primary">GRATIS</strong>.
          </p>
          <a
            class="btn-primary-custom"
            :href="whatsappUrl"
            target="_blank"
            rel="noopener noreferrer"
          >
            Berlangganan Sekarang
          </a>
        </div>
      </div>
      <div class="col-lg-6 col-xl-7">
        <div class="image-container text-center">
          <div class="hero-image-wrapper">
            <img class="img-fluid hero-img" :src="require('@/assets/home-awal.png')" alt="alternative" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getWhatsAppUrl } from "@/services/whatsapp";

export default {
  name: "ImageAndText",
  props: {
    msg: String,
  },
  data() {
    return {
      whatsappUrl: getWhatsAppUrl(),
    };
  },
};
</script>

<style scoped lang="scss">
@import "@/assets/scss/tokens";

.hero-section {
  padding: 160px 0 100px;
  position: relative;

  .h1-large {
    font-size: 3.5rem;
    line-height: 1.2;
    font-weight: 800;

    @media (max-width: 992px) {
      font-size: 2.5rem;
    }
  }

  .p-large {
    font-size: 1.1rem;
    line-height: 1.8;
  }

  .hero-image-wrapper {
    position: relative;

    &::before {
      content: "";
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      width: 120%;
      height: 120%;
      background: radial-gradient(circle, rgba(var(--color-primary-rgb), 0.1) 0%, transparent 70%);
      z-index: -1;
    }
  }

  .hero-img {
    animation: float 6s ease-in-out infinite;
  }
}

// Gradient-mesh: blob warna-warni yang bergeser pelan di belakang hero
.hero-blob {
  position: absolute;
  border-radius: 50%;
  filter: blur(80px);
  opacity: 0.4;
  pointer-events: none;
  z-index: -1;
  animation: blob-drift 24s ease-in-out infinite;

  &--1 {
    width: min(420px, 65vw);
    height: min(420px, 65vw);
    top: 6%;
    right: -6%;
    background: radial-gradient(circle, rgba(var(--color-primary-rgb), 0.35) 0%, transparent 70%);
  }

  &--2 {
    width: min(320px, 50vw);
    height: min(320px, 50vw);
    bottom: -10%;
    left: -8%;
    background: radial-gradient(circle, rgba(var(--accent-edu-rgb), 0.24) 0%, transparent 70%);
    animation-delay: -8s;
  }

  &--3 {
    width: min(280px, 45vw);
    height: min(280px, 45vw);
    top: 30%;
    left: 38%;
    background: radial-gradient(circle, rgba(var(--accent-kantin-rgb), 0.16) 0%, transparent 72%);
    animation-delay: -16s;
  }
}

@keyframes float {
  0% {
    transform: translateY(0px);
  }
  50% {
    transform: translateY(-20px);
  }
  100% {
    transform: translateY(0px);
  }
}

@media (prefers-reduced-motion: reduce) {
  .hero-img,
  .hero-blob {
    animation: none;
  }
}
</style>
